<template>
  <div class="short-chain">
    <!-- 小程序 -->
    <!-- <div class="chain-weapp-content" v-if="promotionType == 1">
      <img
        class="icon-weapp"
        src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/1e1caa39-2d96-46a5-b6b4-26b1d13691d0.png"
      />
      <p class="chain-weapp-name">{{ weappName || "小程序名称" }}</p>
      <p class="chain-weapp-tips">{{ describe || "描述展示" }}</p>
      <div class="chain-btn">
        <span>前往小程序</span>
        <img
          src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/6000b06a-0fbb-434e-a3a5-8e7ad67de5f2.png"
        />
      </div>
    </div> -->
    <!-- 网址 -->
    <div class="chain-weapp-content" v-if="promotionType == 2 && !endTimeFlag">
      <img
        class="icon-website"
        src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/6504e79b-91b4-4987-8fb9-e0dabbd86a1f.png"
      />
      <p class="chain-weapp-name">
        {{ shortChainDetail.name || "网站名称" }}
      </p>
      <p class="chain-weapp-tips">{{ shortChainDetail.des || "描述展示" }}</p>
      <div class="chain-btn" style="background-color: #2e6af8" @click="jumpWebsite()">
        <span>前往网站</span>
        <img
          src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/6000b06a-0fbb-434e-a3a5-8e7ad67de5f2.png"
        />
      </div>
    </div>
    <div class="chain-weapp-content" v-if="endTimeFlag">
      <img
      style="margin-bottom:20px;"
        class="icon-website"
        src="https://assets-service.obs.cn-south-1.myhuaweicloud.com/test/kma/f8563208-8924-4440-a6ec-fe8de0ea94df.png"
      />
      <p class="chain-weapp-tips">抱歉！该链接已失效</p>
    </div>
    <!-- 二维码 -->
    <!-- <div
      class="chain-qrcode-content"
      v-if="promotionType != 1 && promotionType != 2"
    >
      <div class="chain-qrcode-head">
        <img
          src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/9da40bf4-92e2-470a-a1a5-36dce0ddd24b.png"
        />
        <p>
          <span>{{ chainName || "活码名称" }}</span>
          <span>{{ describe || "活码描述展示" }}</span>
        </p>
      </div>
      <div class="chain-qrcode-center">
        <img
          src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/4d4ad4a1-e67c-4700-8c8a-a4e5006c0041.png"
        />
        <p>长按或扫描上方二维码添加微信</p>
      </div>
    </div> -->
    <!-- 聊一聊 -->
    <div class="msg-container" @click="messageFn" v-if="isMessage">
      <img
        class="message-avatar"
        :src="
          'https://assets-service.obs.cn-south-1.myhuaweicloud.com/production/kma/73519d86-5a35-4448-a6a1-46873ce70b54.png'
        "
      />
      <div class="message-text">聊一聊</div>
      <div class="h5-msg" v-if="msgFlag">
        <wx-open-launch-weapp
          id="launch-btn-msg"
          username="gh_3d4c1d810055"
          style="
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            left: 0;
            opacity: 0;
          "
          :path="'pages-user/authorization/index?userId=' + userId"
        >
          <script type="text/wxtag-template">
            <style>
                .btn {
                    display: block;
                    width: 120px;
                    height: 120px;
                }
            </style>
            <button class="btn">跳转</button>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
    <input
      id="copyInput"
      style="
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        z-index: -10;
      "
    />
  </div>
</template>
<script>
import api from "api";
import utils from "@utils/index";
import wx from "weixin-js-sdk";
import { Toast, MessageBox } from "mint-ui";
import httpConfig from "@config/http";
export default {
  name: "shortChain",
  data() {
    return {
      promotionType: "",
      weappName: "小程序",
      describe: "我是描述哇事实上",
      chainName: "我是活码啊",
      isMessage: false, //是否显示聊一聊
      msgFlag: false, //私信开发标签
      userId: "",
      userInfo: {},
      shortChainId: utils.getUrlParam("id") || '',
      shortChainDetail: {}, //短链详情
      endTimeFlag: false, //过期状态
    };
  },
  created() {
    let script = document.createElement('script')
    script.type = 'application/ld+json'
    script.textContent = '{"@context":"https://schema.org","@type":"NewsArticle","mainEntityOfPage":{"@type":"WebPage","headline":"智能短链头部","description":"智能短链描述啊啊啊","datePublished":"2022-08-23T12:59:21.000Z","dateModified":"2022-08-25T14:37:18.000Z","publisher":{"@type":"Organization","name":"智能短链","logo":{"@type":"ImageObject","url":"https://lf3-static.bytednsdoc.com/obj/eden-cn/uhbfnupkbps/216.png"}}}'
    document.getElementsByTagName('head')[0].appendChild(script)
  },
  mounted() {
    this.getDetail();
    //小程序环境走微信授权
    console.log("utils.isMiniprogram()---",utils.isMiniprogram())
    if(utils.isMiniprogram()){
      utils.wxAuth().then(() => {
        // 配置js-sdk
        utils.setJsSdk().then(() => {});
      });
      
    }
  },
  methods: {
    getDetail() {
      let self = this;
      api
        .request("getShortLinkDetail", { id: self.shortChainId })
        .then((result) => {
          if (result.status == 0) {
            let endTime = new Date(result.data.expired.replace(/-/g,'/')).getTime() + 86400000, 
            currentTime = new Date().getTime();
            self.endTimeFlag = (currentTime >= endTime || result.data.deleted == -1) ? true : false;
            self.userId = result.data.relation_userid || "";
            $("title").text(result.data.name || '智能短链');
            $("meta[name='description']").attr('content',result.data.des || '短链描述');
            $("link[rel='shortcut icon']").attr('href','https://assets-service.obs.cn-south-1.myhuaweicloud.com/test/kma/651ac4c0-bfe5-4b55-bffd-9b9af6fae554.jpg')
            // 私信显示
            if (self.userId) {
              self.isMessage = false;
              // if (!!utils.isWX()) {
              //   // h5私信
              //   self.msgFlag = true;
              // }
            }
            if(result.data.type != 2){
              if(currentTime > endTime || result.data.deleted == -1){
                return
              }else{
                //result.data.shortChain
                if(utils.isMiniprogram()){
                  let miniProgramUrl = "/pages-function/applet-middle-page/index?id=" + self.shortChainId + "&origin=wx"
                  wx.miniProgram.navigateTo({ url: miniProgramUrl});
                }else{
                  this.createJump('weapp',result.data.shortChain);
                }
                
              }
            }else{
             
              //浏览埋点
              utils.behaviorGatherFn({
                "relationType": 16,
                "relationId": String(self.shortChainId),
                "clientType": "h5",
                "extType": "view",
                "indexType": "short_link",
              });
              self.shortChainDetail = result.data;
            }
            self.promotionType = result.data.type;
            console.log("短链详情",result.data)
          }else{
            Toast("获取短链信息失败");
          }
        });
    },
    jumpWebsite(){
      // 小程序环境下提示
      if(utils.isMiniprogram()){
        let $input = $("#copyInput"),
        copyText = this.shortChainDetail.subSource.site_url;
        $("body").append($input);
        $input.val(copyText);
        $input.select();
        document.execCommand("copy");
        document.activeElement.blur()
        MessageBox({
          title: '提示',
          message: '已复制链接，请前往外部浏览器打开',
          showCancelButton: false
        });
      }else{
        this.createJump('website',this.shortChainDetail.subSource.site_url);
      }
    },
    //创建跳转
    createJump(id,url){
      var a = document.createElement('a');
      a.id = id;
      a.href = url;
      document.body.appendChild(a);
      var e = document.createEvent('MouseEvent');     
      e.initEvent('click', false, false);     
      document.getElementById(id).dispatchEvent(e);
    },
    //聊一聊
    messageFn() {
      location.href = httpConfig.timHost + "#/?from=" + this.userId
      //小程序
      // if (!!utils.isMiniprogram()) {
      //   wx.miniProgram.navigateTo({
      //     url: "/pages-user/authorization/index?userId=" + this.userId,
      //   });
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.short-chain {
  height: 100vh;
  .icon-weapp {
    width: 95px;
    height: 95px;
  }
  .icon-website {
    width: 108px;
    height: 108px;
  }
  // 小程序
  .chain-weapp-content {
    text-align: center;
    margin-top: 380px;
    .chain-weapp-name {
      width: 480px;
      font-size: 32px;
      color: #333333;
      margin: 17px auto 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .chain-weapp-tips {
      font-size: 32px;
      color: #999999;
      margin-bottom: 118px;
    }
    .chain-btn {
      width: 673px;
      height: 100px;
      font-size: 32px;
      color: #ffffff;
      border-radius: 16px;
      background-color: #07c160;
      padding: 0 26px 0 43px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      img {
        width: 53px;
        height: 53px;
      }
    }
  }
  // 二维码
  .chain-qrcode-content {
    font-size: 12px;
    text-align: center;
    margin-top: 84px;
    .chain-qrcode-head {
      display: flex;
      margin: 0 0 150px 37px;
      & > img {
        width: 120px;
        height: 120px;
      }
      p {
        display: flex;
        flex-direction: column;
        font-size: 28px;
        color: #999999;
        margin-left: 13px;
        justify-content: center;
        text-align: left;
        & > span {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        & > span:first-child {
          width: 407px;
          font-size: 32px;
          color: #333333;
          margin-bottom: 10px;
        }
        & > span:last-child {
          width: 468px;
        }
      }
    }
    .chain-qrcode-center {
      img {
        width: 556px;
        height: 556px;
      }
      p {
        font-size: 28px;
        color: #999999;
        margin-top: 42px;
      }
    }
  }
  // 聊一聊
  .msg-container {
    position: fixed;
    right: 30px;
    bottom: 175px;
    width: 120px;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 50%;
    .message-avatar {
      // width: 120px;
      // height: 120px;
      border-radius: 50%;
      box-shadow: 2px 5px 5px -4px #333333;
      border: 4px solid #ffffff;
    }

    .message-text {
      position: absolute;
      bottom: -20px;
      width: 92px;
      height: 32px;
      background: #2e6af8;
      box-shadow: 0px 4px 12px rgba(100, 101, 102, 0.2);
      border-radius: 16px;
      font-size: 20px;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
    }
    .h5-msg {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: transparent;
      z-index: 19999;
      overflow: hidden;
    }
  }
}
</style>